export enum TypeReportReceived {
  SIMPLE = "SIMPLE",
  CONTABILIZACION = "CONTABILIZACION",
}
